import React from "react";
import { Link } from "react-router-dom";

const TYPES = [
  { key: "particulier", label: "Particulier" },
  { key: "professionnel", label: "Professionnel" },
];

const inputCls =
  "w-full rounded-xl border border-[var(--oz-border)] px-3 py-2.5 text-sm outline-none focus:border-[var(--oz-gold)]";

export const isBuyerValid = (b) =>
  b.cgv && (b.type !== "professionnel" || (b.company.trim() && /^\d{14}$/.test(b.siret.replace(/\s/g, ""))));

export const buyerPayload = (b) => ({
  cgv_accepted: b.cgv,
  buyer_type: b.type,
  company_name: b.type === "professionnel" ? b.company.trim() : null,
  siret: b.type === "professionnel" ? b.siret.replace(/\s/g, "") : null,
});

export const BuyerTerms = ({ buyer, onChange, onNavigate }) => {
  const set = (patch) => onChange({ ...buyer, ...patch });
  const siretBad = buyer.siret && !/^\d{14}$/.test(buyer.siret.replace(/\s/g, ""));
  return (
    <div className="pt-1 space-y-3" data-testid="buyer-terms">
      <div>
        <p className="text-sm font-semibold text-[var(--oz-text)] mb-2">Vous commandez en tant que</p>
        <div className="grid grid-cols-2 gap-2">
          {TYPES.map((t) => (
            <button
              key={t.key}
              type="button"
              data-testid={`buyer-type-${t.key}`}
              onClick={() => set({ type: t.key })}
              className={`px-3 py-2.5 rounded-xl text-sm font-semibold border transition-colors ${
                buyer.type === t.key
                  ? "border-[var(--oz-dark)] bg-[var(--oz-dark)] text-white"
                  : "border-[var(--oz-border)] text-[var(--oz-muted)] hover:border-[var(--oz-dark)]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {buyer.type === "professionnel" && (
        <div className="space-y-2" data-testid="buyer-pro-fields">
          <input
            data-testid="buyer-company-input"
            value={buyer.company}
            onChange={(e) => set({ company: e.target.value })}
            placeholder="Raison sociale *"
            className={inputCls}
          />
          <input
            data-testid="buyer-siret-input"
            value={buyer.siret}
            onChange={(e) => set({ siret: e.target.value })}
            placeholder="SIRET (14 chiffres) *"
            inputMode="numeric"
            className={inputCls}
          />
          {siretBad && (
            <p data-testid="buyer-siret-error" className="text-[11px] text-[var(--oz-badge)]">
              Le SIRET doit contenir exactement 14 chiffres.
            </p>
          )}
        </div>
      )}

      <label className="flex items-start gap-2 cursor-pointer text-xs text-[var(--oz-muted)] leading-relaxed">
        <input
          type="checkbox"
          data-testid="cgv-checkbox"
          checked={buyer.cgv}
          onChange={(e) => set({ cgv: e.target.checked })}
          className="mt-0.5 w-4 h-4 accent-[var(--oz-gold)] flex-shrink-0"
        />
        <span>
          J'ai lu et j'accepte les{" "}
          <Link to="/legal/cgv" onClick={onNavigate} data-testid="cgv-link" className="underline text-[var(--oz-text)]">
            Conditions Générales de Vente
          </Link>{" "}
          *
        </span>
      </label>
    </div>
  );
};
